/* tslint:disable */
/* eslint-disable */
/**
 * LogQS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ObjectStoreUpdateRequest {
  bucketName?: string;
  accessKeyId?: string | null;
  secretAccessKey?: string | null;
  regionName?: string | null;
  endpointUrl?: string | null;
  note?: string | null;
  context?: object | null;
  disabled?: boolean;
}

export function ObjectStoreUpdateRequestFromJSON(
  json: any,
): ObjectStoreUpdateRequest {
  return ObjectStoreUpdateRequestFromJSONTyped(json);
}

export function ObjectStoreUpdateRequestFromJSONTyped(
  json: any,
): ObjectStoreUpdateRequest {
  if (json == null) {
    return json;
  }

  return {
    bucketName: json["bucket_name"],
    accessKeyId: json["access_key_id"],
    secretAccessKey: json["secret_access_key"],
    regionName: json["region_name"],
    endpointUrl: json["endpoint_url"],
    note: json["note"],
    context: json["context"],
    disabled: json["disabled"],
  };
}

export function ObjectStoreUpdateRequestToJSON(
  value: ObjectStoreUpdateRequest | null | undefined,
): any {
  if (value == null) {
    return value;
  }

  return {
    bucket_name: value.bucketName,
    access_key_id: value.accessKeyId,
    secret_access_key: value.secretAccessKey,
    region_name: value.regionName,
    endpoint_url: value.endpointUrl,
    note: value.note,
    context: value.context,
    disabled: value.disabled,
  };
}
